import theme from "@/theme";

export const styles = {
  wrapper: {
    zIndex: 1000,
    position: "absolute",
    right: "20px",
    top: "90px",
    borderRadius: "1rem",
    width: "100%",
    maxWidth: 375,
    overflow: "hidden",
    backdropFilter: "blur(2rem)",
    height: "calc(100vh - 100px)",
    maxHeight: "802px",
    boxShadow:
      " 0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05), 0 40px 64px -12px rgba(0, 0, 0, 0.08)",
    background: theme.palette.custom.mainWhite,
  },
  header: {
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  tabStyle: (tabValue: number, tabIndex: number) => ({
    minHeight: "24px",
    height: "24px",
    padding: "0 0 4px 0",
    fontFamily: "Inter",
    fontWeight: tabValue === tabIndex ? 600 : 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: 0,
    verticalAlign: "middle",
    textTransform: "none",
    minWidth: "unset",
    // width: tabValue === 1 ? "104px" : "46px",
    color: tabValue === tabIndex ? theme.palette.custom.mainBlue : theme.palette.custom.blueGray700,
    "&.Mui-selected": { backgroundColor: "transparent" },
    "&:hover": { backgroundColor: "transparent" },
    "&:focus": { outline: "none", backgroundColor: "transparent" },
  }),

  tabPanel: {
    minHeight: "24px",
    "& .MuiTabs-flexContainer": {
      gap: "2px",
    },
    "& .MuiTabs-indicator": {
      height: "2px",
      borderRadius: 2,
      backgroundColor: theme.palette.custom.mainBlue,
      bottom: 0,
      margin: "0 auto",
      transition: "width 0.2s ease",
    },
  },

  notificationWrapper: {
    maxHeight: "96%",
    overflow: "auto",
    padding: "0 0 20px 0",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },

    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
  },

  notificationItem: {
    position: "relative",
    gap: "6px",
    cursor: "pointer",
    margin: 0,
    padding: "12px 14px",
    borderBottom: "1px solid #E6ECF1",
    transition: "background-color 0.6s ease",
    "&:last-of-type": {
      borderBottom: "none",
    },
    "&:hover": { bgcolor: "rgba(0, 0, 0, 0.04)" },
  },

  notificationItemHighlight: {
    bgcolor: "rgba(240, 247, 255, 0.7)",
    "&:hover": { bgcolor: "rgba(225, 238, 255, 0.9)" },
  },

  notificationAvatar: {
    height: "40px",
    width: "40px",
    flexShrink: 0,
    borderRadius: "50%",
    position: "relative",
  },

  notificationUnread: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "0.75rem",
    height: "0.375rem",
    width: "0.375rem",
    bgcolor: theme.palette.custom.mainBlue,
    borderRadius: "50%",
  },
};
